import * as $ from 'jquery';
import * as i18n from 'CMS/core/i18n';
import * as kendo from 'kendo/kendo.core';
import * as app from 'CMS/core/application';
import * as page from 'CMS/core/page';
import { alert } from 'CMS/UI/Popup';
import { BaseDialog } from 'visuris/Dialogs/BaseDialog';

export default class ShipTypeByCEMTSelectionDialog extends BaseDialog {

    private shipTypes: Map<string, any> = null;

    protected buildContent(): Promise<JQuery> {
        return new Promise<JQuery>((resolve, reject) => {
            if (this.shipTypes != null) {
                resolve(this.buildContentWithShipTypes(this.shipTypes));
            } else {
                $.get(app.formatLocationUrl('{AWFVlist}/OData/Lists.svc/ShipTypesByCEMTList?$format=json')).then((data) => {
                    this.shipTypes = new Map<string, any>();
                    for (let i = 0; i < data.value.length; i++) {
                        this.shipTypes.set(data.value[i].id, data.value[i]);
                    }
                    resolve(this.buildContentWithShipTypes(this.shipTypes));
                }, (error) => {
                    console.error(error);
                    alert(i18n.getMessage('dialog.serviceUnavailable'));
                    reject();
                });
            }
        });
    }

    protected setInitialSelection(selection: any) { }

    private buildContentWithShipTypes(shipTypes: Map<string, any>): JQuery {
        var content = '<div class="ship-types-cemt-selection">';
        content += '<div class="row clear-side-margin ship-types-cemt-filters">';
        content += '<div class="ship-types-cemt-filter"><span class="col-md-1">Ton: </span><input type="number" min="0" step="1" class="col-md-2 cemt-filter filter-ton" /></div>';
        content += '<div class="ship-types-cemt-filter"><span class="col-md-1">TEU: </span><input type="number" min="0" step="1" class="col-md-2 cemt-filter filter-teu" /></div>';
        content += '<button type="button" class="btn btn-link button-clear-cemt-filters capitalize">' + i18n.getMessage('filters.clearAll') + '</button>';
        content += '</div>';
        content += '<div class="ship-types-cemt-list">';
        shipTypes.forEach((shipType) => {
            content += this.buildShipTypeItem(shipType);
        });
        content += '</div>';
        content += '</div>';
        return $(content);
    }

    protected completeContent($content: JQuery) {
        // Selection
        $content.find('.ship-type-cemt').on('click', (e) => {
            var $shipType = $(e.currentTarget);
            $content.find('.ship-type-cemt').toggleClass('selected', false);
            $shipType.toggleClass('selected', true);
            this.selectionChanged(this.shipTypes.get($shipType.data('id')));
        });

        // Clear filters
        $content.find('.button-clear-cemt-filters').on('click', (e) => {
            e.preventDefault();
            $content.find('.cemt-filter').val('');
            this.onFilterChanged($content);
        });

        // Filter
        $content.find('.cemt-filter').on('change', (e) => {
            this.onFilterChanged($content);
        });
    }

    private buildShipTypeItem(shipType: any): string {
        var shipTypeTranslation: string;
        switch (page.getCurrentLanguage().code) {
            case 'nl':
                shipTypeTranslation = shipType.shiptype_nl;
                break;
            case 'en':
                shipTypeTranslation = shipType.shiptype_en;
                break;
            case 'fr':
                shipTypeTranslation = shipType.shiptype_fr;
                break;
            case 'de':
                shipTypeTranslation = shipType.shiptype_de;
                break;
            case 'bg':
                shipTypeTranslation = shipType.shiptype_bg;
                break;
            case 'cs':
                shipTypeTranslation = shipType.shiptype_cs;
                break;
            case 'hr':
                shipTypeTranslation = shipType.shiptype_hr;
                break;
            case 'hu':
                shipTypeTranslation = shipType.shiptype_hu;
                break;
            case 'ro':
                shipTypeTranslation = shipType.shiptype_ro;
                break;
            case 'sk':
                shipTypeTranslation = shipType.shiptype_sk;
                break;
            case 'sr':
                shipTypeTranslation = shipType.shiptype_sr;
                break;
            default:
                shipTypeTranslation = '';
                break;
        }
        var item = '<div class="row ship-type-cemt clear-side-margin" data-id="' + shipType.id + '">';
        item += '<div class="col-sm-1 cemt-class">';
        item += '<p>' + shipType.cemt + '</p>';
        item += '</div>';
        item += '<div class="col-sm-9 ship-type-description">';
        item += '<p><strong>' + shipTypeTranslation + '</strong><span class="cemt-filter-amount"></span>';
        if (shipType.maxlen && shipType.maxwidth) {
            item += '<br />' + i18n.getMessage('cemt.length') + ': ' + shipType.maxlen + ' m - ' + i18n.getMessage('cemt.width') + ': ' + shipType.maxwidth + ' m';
        } else if (shipType.maxlen) {
            item += '<br />' + i18n.getMessage('cemt.length') + ': ' + shipType.maxlen + ' m';
        } else if (shipType.maxwidth) {
            item += '<br />' + i18n.getMessage('cemt.width') + ': ' + shipType.maxwidth + ' m';
        }
        if (shipType.maxdraught && shipType.maxheight) {
            item += '<br />' + i18n.getMessage('cemt.draught') + ': ' + shipType.maxdraught + ' m - ' + i18n.getMessage('cemt.height') + ': ' + shipType.maxheight + ' m';
        } else if (shipType.maxdraught) {
            item += '<br />' + i18n.getMessage('cemt.draught') + ': ' + shipType.maxdraught + ' m';
        } else if (shipType.maxheight) {
            item += '<br />' + i18n.getMessage('cemt.height') + ': ' + shipType.maxheight + ' m';
        }
        if (shipType.maxspeed) {
            item += '<br />' + i18n.getMessage('cemt.speed') + ': ' + shipType.maxspeed;
        }
        if (shipType.maxton) {
            item += '<br />' + i18n.getMessage('cemt.loadCapacity') + ': ' + shipType.maxton + ' ton';
        } else if (shipType.maxteu) {
            item += '<br />' + i18n.getMessage('cemt.loadCapacity') + ': ' + shipType.maxteu + ' TEU';
        }
        item += '</p>';
        if (shipType.imageurl) {
            item += '<img src="' + shipType.imageurl + '" />';
        }
        item += '</div>';
        item += '</div>';
        return item;
    }

    private onFilterChanged($content: JQuery) {
        var ton = Number($content.find('.filter-ton').val());
        var teu = Number($content.find('.filter-teu').val());
        if ((ton === 0 && teu === 0) || (ton > 0 && teu > 0)) {
            // No filters or cannot apply both filters at the same time
            $content.find('.ship-type-cemt').toggleClass('hidden', false);
            $content.find('.cemt-filter-amount').html('');
        } else {
            var shipTypesToShow = new Map<string, number>();
            if (ton > 0) {
                // Filter ton
                this.shipTypes.forEach((shipType) => {
                    if (shipType.maxton) {
                        shipTypesToShow.set(shipType.id, Math.ceil(ton / shipType.maxton));
                    }
                });
            }
            if (teu > 0) {
                // Filter teu
                this.shipTypes.forEach((shipType) => {
                    if (shipType.maxteu) {
                        shipTypesToShow.set(shipType.id, Math.ceil(teu / shipType.maxteu));
                    }
                });
            }
            this.applyFilters($content, shipTypesToShow);
        }
    }

    private applyFilters($content: JQuery, shipTypes: Map<string, number>) {
        $content.find('.ship-type-cemt').toggleClass('hidden', true);
        shipTypes.forEach((amount, id) => {
            if (amount > 0) {
                var $shipType = $content.find('[data-id="' + id + '"]');
                $shipType.toggleClass('hidden', false);
                $shipType.find('.cemt-filter-amount').html('(x' + amount.toString() + ')');
            }
        });
    }

}